module.exports = __webpack_public_path__ + "img/waiting.630d9214.svg";